/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import {LocaleProvider} from 'antd'
import fa_IR from 'antd/lib/locale-provider/fa_IR'
import moment from 'moment'
import 'moment/locale/fa'

import App from './Component/App/App.js'

// import "font-awesome/css/font-awesome.min.css";
// import "bootstrap-css-only/css/bootstrap.min.css";
import 'mdbreact/dist/css/mdb.css'
import './index.css'

moment.locale('fa')

ReactDOM.render(
  <LocaleProvider locale={fa_IR}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </LocaleProvider>,

  document.getElementById('main')
)
